import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RunningThresholdJob } from 'custom_hooks/data_hooks/jobs/runningAlertThresholdJobs.shared';
import { ThresholdJobsRunningWarning } from 'pages/workbench/shared/threshold_jobs/ThresholdJobsRunningWarning';
import { IconRow, StyledWarningCard } from './styled';

const VisibleRunningJobsCount = 3;

export type RunningThresholdJobsWarningCardProps = Readonly<{
    runningThresholdJobs?: RunningThresholdJob[];
    runningThresholdJobsError?: boolean;
}>;

export function RunningThresholdJobsWarningCard({
    runningThresholdJobs,
    runningThresholdJobsError,
}: RunningThresholdJobsWarningCardProps) {
    return (
        <StyledWarningCard className="p-10 mb-10">
            <IconRow>
                <FontAwesomeIcon icon={faExclamationTriangle} />{' '}
                <span>
                    Changes here will update all warning, alarm, and critical alarm
                    thresholds within the selected hierarchy
                </span>
            </IconRow>
            <ThresholdJobsRunningWarning
                runningThresholdJobs={runningThresholdJobs}
                runningThresholdJobsError={runningThresholdJobsError}
                visibleJobs={VisibleRunningJobsCount}
                verbose={false}
            />
        </StyledWarningCard>
    );
}
